// extracted by mini-css-extract-plugin
export default {"base":"Dialog_base__mzU96","content":"Dialog_content__yVyEO"};